import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Sales from '../Sales/Sales';
import { useNavigate } from 'react-router-dom';
import Stockallocation from './Stockallocation';
import MainStore from './MainStore';
import SecondStore from './SecondStore';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  const navigate = useNavigate();

  React.useEffect(() => {

    

    if(!localStorage.getItem("user") || (JSON.parse(localStorage.getItem("loggedDetails")).role).toUpperCase() !== 'ADMIN'){
      navigate("/Login")
    }
    

  }, [])
  

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Stock Allocation" {...a11yProps(0)} />
          <Tab label="Main Stote - Warakapola" {...a11yProps(1)} />
          <Tab label="Seond Store - Galigamuwa" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Stockallocation/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <MainStore/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <SecondStore/>
      </CustomTabPanel>
    </Box>
  );
}
